<template>
  <div class="mb-3 p-3 bg-light rounded">
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <div class="mb-1">
          <small class="fw-bold">
            "Shows when parent is answered :
            <span class="fw-bold">{{ node.trigger_condition }}</span>"
          </small>
        </div>

        <label class="text-dark text-xs fw-medium mb-1 text-capitalize">
          {{ index + 1 }}. {{ node.question_text }}
          <span v-if="node.is_mandatory" class="text-danger ms-1">*</span>
        </label>

        <!-- Options -->
        <div
          v-if="isSelectType && node.options && node.options.length"
          class="ms-3 mt-2"
        >
          <p class="text-xs text-dark mb-1">Options:</p>
          <ul class="list-unstyled ms-2">
            <li
              v-for="(option, i) in node.options"
              :key="i"
              class="text-xs text-dark mb-1"
            >
              <span class="text-muted me-1">•</span>
              {{ typeof option === 'object' ? option.choice : option }}
            </li>
          </ul>
        </div>
      </div>

      <div class="d-flex gap-1">
        <button
          class="btn btn-outline-primary btn-sm border-0 text-xxs"
          @click="$emit('edit', node)"
          data-bs-toggle="modal"
          data-bs-target="#edit_preview_question"
        >
          <i class="bi bi-pencil-fill text-x"></i>
        </button>

        <button
          class="btn btn-outline-danger btn-sm border-0 text-xxs"
          @click="$emit('remove', node)"
        >
          <i class="bi bi-trash-fill text-x"></i>
        </button>

        <button
          v-if="hasChildren"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow"
          @click="open = !open"
        >
          {{ open ? 'Hide' : 'Show' }} More
          <span class="fw-bold ms-1">{{ node.dependent_questions.length }}</span>
        </button>
      </div>
    </div>

    <div v-if="hasChildren && open" class="mt-3 ms-4 border-start border-3 border-primary ps-3">
      <PreviewFormRecursiveDependentQuestion
        v-for="(child, childIndex) in node.dependent_questions"
        :key="child.question_id || child.id"
        :node="child"
        :index="childIndex"
        @edit="$emit('edit', $event)"
        @remove="$emit('remove', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewFormRecursiveDependentQuestion",
  props: {
    node: { type: Object, required: true },
    index: { type: Number, default: 0 },
  },
  data() {
    return { open: false };
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.node?.dependent_questions) && this.node.dependent_questions.length > 0;
    },
    isSelectType() {
      const t = this.node?.question_type?.question_type || this.node?.question_type;
      return ["multi_select", "single_select"].includes(t);
    },
  },
};
</script>
